import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InputContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 4px;
  margin: 8px auto;
`;

const InputLabel = styled.label`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 4px;
  display: inline-block;
`;

const InputSubLabel = styled.div`
  font-style: italic;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 8px;
  color: #484848;  
`;

const InputFieldContainer = styled.div`
  width: 100%;
  padding: 8px;
  border: 2px solid ${({ error }) => (error ? '#EA0000' : '#DBDEE2')};
  border-radius: 4px;
  background-color: ${({ disabled }) => (disabled ? '#DBDEE2' : 'unset')};
`;

const InputField = styled.input`
  width: 100%;
  border: none;
  outline-width: 0;
  background-color: ${({ disabled }) => (disabled ? '#DBDEE2' : 'initial')};
`;

const InputHelper = styled.div`
  color: ${({ error, helperColor }) => helperColor || (error ? '#EA00000' : 'unset')};
  text-align: left;
  font-size: 14px;
`;

const TextInput = ({
  className,
  label,
  sublabel,
  helper,
  error,
  readOnly,
  autoFocus,
  defaultValue,
  helperColor,
  placeholder,
  onChange,
  onKeyPress,
}) => (
  <InputContainer className={className}>
    <InputLabel>
      {label}
    </InputLabel>
    {sublabel && (
      <InputSubLabel>
        {sublabel}
      </InputSubLabel>
    )}
    <InputFieldContainer disabled={readOnly} error={error}>
      <InputField
        autoFocus={autoFocus}
        readOnly={readOnly}
        defaultValue={defaultValue}
        disabled={readOnly}
        placeholder={placeholder}
        onChange={({ target }) => onChange(target)}
        onKeyUp={onKeyPress}
      />
    </InputFieldContainer>
    {!!helper && (
      <InputHelper error={error} helperColor={helperColor}>
        {helper}
      </InputHelper>
    )}
  </InputContainer>
);

TextInput.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  sublabel: PropTypes.string,
  defaultValue: PropTypes.string,
  helper: PropTypes.string,
  helperColor: PropTypes.string,
  error: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
};

TextInput.defaultProps = {
  autoFocus: false,
  className: '',
  label: '',
  sublabel: PropTypes.string,
  helper: '',
  defaultValue: undefined,
  helperColor: 'unset',
  error: false,
  placeholder: '',
  readOnly: false,
  onChange: () => {},
  onKeyPress: () => {},
};

export default TextInput;
